module.exports = __webpack_public_path__ + "static/img/home-img3.31ad918.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img3.png
// module id = xWvX
// module chunks = 1